var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3559_549)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 20C40 8.95514 31.0449 0 20 0C8.95514 0 0 8.95514 0 20C0 29.9817 7.31261 38.2562 16.8753 39.7581V25.7826H11.7958V20H16.8753V15.5927C16.8753 10.5808 19.8622 7.81043 24.4298 7.81043C26.6179 7.81043 28.9073 8.20138 28.9073 8.20138V13.1233H26.3845C23.901 13.1233 23.1247 14.6646 23.1247 16.2481V20H28.6711L27.7851 25.7826H23.1247V39.7581C32.6874 38.259 40 29.9845 40 20Z",
    fill: "#1977F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7846 25.7827L28.6705 20.0001H23.1242V16.2482C23.1242 14.6675 23.8976 13.1234 26.3839 13.1234H28.9068V8.20149C28.9068 8.20149 26.6174 7.81055 24.4292 7.81055C19.8616 7.81055 16.8747 10.5781 16.8747 15.5929V20.0001H11.7953V25.7827H16.8747V39.7582C17.8929 39.9186 18.9363 40.0001 19.9994 40.0001C21.0626 40.0001 22.106 39.9157 23.1242 39.7582V25.7827H27.7846Z",
    fill: "#FEFEFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3559_549"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/Facebook_Icon.e8e5819505c99711e03a599e02c56f11.svg";
export { ForwardRef as ReactComponent };